import React from 'react'

export default function About() {
  return (
    <div className="min-h-screen bg-[#111c3ef3] md:p-12 p-4">
      <h1 className="md:text-6xl text-4xl text-center font-serif mt-8 text-[#7FFFD4] font-semibold mb-8 underline underline-offset-2"> ⚙️ About me</h1>

      <h2 className=' text-[#F5DEB3] font-bold md:text-3xl text-2xl  md:p-12 md:px-24' >I am Yash Bawa pursuing Bachelors in Computer Science from VIT following my passion to learn coding and development .</h2>
      
      <p className=' text-[#F5DEB3] font-bold md:text-2xl text-xl md:p-12 md:px-24' >
            I am quick learner and always enthusiastic to learn more and more .
        Currently I am exploring Web Development  and its various components which interest me a lot !!     
        Computer Science is a very diverse and deep  field , and am exploring its each chapter every other  day .
      </p>
    </div>
  );
}
